import { lazy, useContext, useEffect } from "react";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { useUserData } from "src/context/userContext";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { KeikkaRemindersProvider } from "src/context/KeikkaRemindersContext";
import { pvmStringLong, scroll6IfTop } from "src/components/js/statics1";
import { GridContext } from "src/context/GridContext/GridContext";

const GridLayout = lazy(() => import("./GridLayout"));

export default function GridCore() {
  const { auth, userAsiakas, isLoading } = useUserData();
  const { time, isLoaded } = useContext(GridContext) || {};

  useEffect(() => {
    //if isLoaded is undefined, reload the page
    if (isLoaded === undefined) {
      console.log("isLoaded is undefined, reloading the page");
      window.location.reload();
      return;
    }
    if (import.meta.env.VITE_ISDEBUG === "yes") console.log("useEffect mount");
    const relUrl = window.location.pathname;
    localStorage.setItem("lastKnownUrl", relUrl);
    document.title = "Grid " + pvmStringLong(time.starttime);
  }, []);

  useEffect(() => {
    if (isLoaded) scroll6IfTop();
  }, [isLoaded]);

  if (isLoading) return <ProgressBar show />;
  if (!userAsiakas) return <div>Käyttäjän asiakastietoja ei löydy</div>;
  if (!userAsiakas.auth) return <div>Käyttäjän autentikointitietoja ei löydy</div>;
  if (!auth.page.grid.read) return <div>Et ole oikeutettu näkemään tätä sivua (GridCore)</div>;

  if (isLoaded === false || isLoaded === true) {
    return (
      <AuthAccess page="grid" showError>
        <KeikkaRemindersProvider>
          <LazyLoader>
            <GridLayout />
          </LazyLoader>
        </KeikkaRemindersProvider>
      </AuthAccess>
    );
  }
}
